export default solution => (solution.url || solution.name[0]).trim().replace(/\s+/g, '-');



// WEBPACK FOOTER //
// ./src/utils/solutionSlug.js